const GET_DATA_FROM_API = 'GET_DATA_FROM_API';
const ASYNC_FETCH = 'ASYNC_FETCH';
const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';
const ERR_OCCURED = 'ERR_OCCURED';
const GET_DATA_FROM_APP_SCHEDULE = 'GET_DATA_FROM_APP_SCHEDULE';
const GET_DATA_FROM_APP_SCHEDULE_SUCCESS = 'GET_DATA_FROM_APP_SCHEDULE_SUCCESS';
const GET_DATA_FROM_APP_SCHEDULE_FAIL = 'GET_DATA_FROM_APP_SCHEDULE_FAIL';
const SUBMIT_ORDER = 'SUBMIT_ORDER';
const SUBMIT_SUCCESS_ORDERWRITE = 'SUBMIT_SUCCESS_ORDERWRITE';
const POST_DATA_SELF_INSTALLATION = 'POST_DATA_SELF_INSTALLATION';
const POST_DATA_SELF_INSTALLATION_SUCCESS = 'POST_DATA_SELF_INSTALLATION_SUCCESS';
const POST_DATA_PRO_INSTALLATION = 'POST_DATA_PRO_INSTALLATION';
const POST_DATA_PRO_INSTALLATION_SUCCESS = 'POST_DATA_PRO_INSTALLATION_SUCCESS';
const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS';
const NO_SLOTS_AVAILABLE = 'NO_SLOTS_AVAILABLE';
const ERORR_SUBMIT = 'ERORR_SUBMIT';
const ORDERWRITE_CASE_ERROR = 'ORDERWRITE_CASE_ERROR';
const EMAIL_VALIDATION_APPOINTMENT_API = 'EMAIL_VALIDATION_APPOINTMENT_API';
const ACCOUNT_MAINTENENCE_APPOINTMENT_EMAIL_VERIFICATION = 'ACCOUNT_MAINTENENCE_APPOINTMENT_EMAIL_VERIFICATION';
const ACC_MAIN_EMAIL_VALIDATION = 'ACC_MAIN_EMAIL_VALIDATION';
const CEF_APPOINTMENT_ERROR = 'CEF_APPOINTMENT_ERROR';
const DEFAULT_ERROR_MESSAGE = 'Looks like something went wrong. Please try again later.';
const BUTTON_DISABLE = 'BUTTON_DISABLE';
const SELF_CONVERSION_BUTTON_MOBILE = 'Continue';
const NON_VZ_CHECKBOX_VALUE = 'NON_VZ_CHECKBOX_VALUE';
export {
  GET_DATA_FROM_API,
  ASYNC_FETCH,
  ASYNC_FETCH_SUCCESS,
  GET_DATA_SUCCESS,
  ERR_OCCURED,
  GET_DATA_FROM_APP_SCHEDULE,
  GET_DATA_FROM_APP_SCHEDULE_SUCCESS,
  GET_DATA_FROM_APP_SCHEDULE_FAIL,
  SUBMIT_ORDER,
  SUBMIT_SUCCESS_ORDERWRITE,
  POST_DATA_SELF_INSTALLATION,
  POST_DATA_SELF_INSTALLATION_SUCCESS,
  POST_DATA_PRO_INSTALLATION,
  POST_DATA_PRO_INSTALLATION_SUCCESS,
  SUBMIT_SUCCESS,
  NO_SLOTS_AVAILABLE,
  ERORR_SUBMIT,
  ORDERWRITE_CASE_ERROR,
  EMAIL_VALIDATION_APPOINTMENT_API,
  ACCOUNT_MAINTENENCE_APPOINTMENT_EMAIL_VERIFICATION,
  ACC_MAIN_EMAIL_VALIDATION,
  CEF_APPOINTMENT_ERROR,
  DEFAULT_ERROR_MESSAGE,
  BUTTON_DISABLE,
  SELF_CONVERSION_BUTTON_MOBILE,
  NON_VZ_CHECKBOX_VALUE,
};
